/* eslint-disable react-hooks/exhaustive-deps */
import { Button, createStyles, FormControlLabel, FormGroup, Grid, makeStyles, Switch, Theme } from '@material-ui/core';
import { FormApi } from 'final-form';
import gql from 'graphql-tag';
import React, { useState } from 'react';
import { useMutation } from 'react-apollo';
import { AnyObject, Field, Form, FormSpy } from 'react-final-form';
import { showNotification } from '../../App';
import { RvLoader } from '../../components/Loader';
import { TaskPublisherSettings } from '../ApplicationSettingsRepository';
import { useTenant } from '../../hooks/useTenant';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
            flex: 1,
            flexFlow: 'column',
            padding: '0 30px',
        },
        textField: {
            width: '100%'
        },
        buttonWrapper: {
            margin: '0 -10px',
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-end',
            '& > button': {
                margin: '0 10px',
            }
        },
        loaderWrapper: {
            display: 'flex',
            justifyContent: 'center',
            flex: 1,
        },
        formGroup: {
            alignItems: 'flex-start',
            '& .MuiFormControlLabel-root': {
                marginLeft: 0,
            }
        }
    })
);

interface FormState {
    publishTasks: boolean;
    publishSuperDiaryTasks: boolean;
}
interface TaskPublishingTabState {
    isLoading: boolean;
    isFormChanged: boolean;
    onSubmitLoading: boolean;
}

interface TaskPublisherTabProps {
    data: TaskPublisherSettings | null;
    onSave?: (data: TaskPublisherSettings | null) => void;
}

export default function TaskPublishingTab(props: TaskPublisherTabProps) {

    const classes = useStyles();

    const tenant = useTenant();

    const [state, setState] = useState<TaskPublishingTabState>({
        isLoading: false,
        isFormChanged: false,
        onSubmitLoading: false,
    });

    const [formState] = useState<FormState>({
        publishTasks: props.data && props.data.config ? props.data.config.publishTasks : false,
        publishSuperDiaryTasks: props.data && props.data.config ? props.data.config.publishSuperDiaryTasks : false
    });

    // tslint:disable-next-line: no-any
    const [updateTaskPublishingMutation] = useMutation<any, TaskPublishingMutationParams>(TASK_PUBLISHING_MUTATION);

    // tslint:disable-next-line: no-any
    const onFormValueChanged = (changeProps: any) => {
        if (!changeProps.pristine) {
            setState((prevState) => {
                return {
                    ...prevState,
                    isFormChanged: true
                };
            });
        }
    };

    // tslint:disable-next-line: no-any
    // const required = (value: any) => {
    //     return value ? undefined : 'Required';
    // };

    const onReset = (form: FormApi<FormState>) => () => {
        form.setConfig('keepDirtyOnReinitialize', false);
        form.batch(() => {
            form.reset();
        });
        form.setConfig('keepDirtyOnReinitialize', true);
    };

    const onSubmit = (form: FormApi<FormState>, values: AnyObject) => {

        // tslint:disable-next-line: no-console
        updateTaskPublishingMutation({
            variables: {
                publishTasks: values.publishTasks,
                publishSuperDiaryTasks: values.publishSuperDiaryTasks
            }
        })
        // tslint:disable-next-line: no-any
        .then((results: { data: any }) => {
            if (results.data) {
                showNotification(null, 'Successfully submitted', 'info'); 
                
                if (props.onSave && props.data) {
                    const tempData = props.data;
                    tempData.config.publishTasks = values.publishTasks;
                    tempData.config.publishSuperDiaryTasks = values.publishSuperDiaryTasks;
                    props.onSave(tempData);
                }
            }
        })
        // tslint:disable-next-line:no-any
        .catch((reason: any) => {
            showNotification('Failed to update task publisher.', reason, 'error');
            setState((_prevState) => {
                return {
                    ..._prevState,
                    onSubmitLoading: false
                };
            });
        });
    };

    if (state.isLoading || tenant.loading) {
        return (
            <div className={classes.root}>
                <div className={classes.loaderWrapper}>
                    <RvLoader />
                </div>
            </div>
        );
    } 

    return (
        <div className={classes.root}>
            <Form
                onSubmit={(values, form: FormApi<FormState>) => onSubmit(form, values)}  
                initialValues={formState}
                initialValuesEqual={() => true}
                keepDirtyOnReinitialize={true}
                subscription={{
                    submitting: true,
                    pristine: true
                }}
                render={({
                    handleSubmit,
                    form,
                    submitting,
                    pristine,
                    values
                }) => (
                    <form onSubmit={handleSubmit} id="TaskPublishingTab">
                        <FormSpy 
                            subscription={{ pristine: true }}
                            // tslint:disable-next-line: no-shadowed-variable
                            onChange={props => {
                                onFormValueChanged(props);
                            }}
                        />
                        
                        <Grid container={true} spacing={3}>
                            <Grid item={true} xs={12} md={12} justify="flex-start">
                                <FormGroup
                                    className={classes.formGroup}
                                >
                                    <Field
                                        name="publishTasks"
                                        subscription={{touched: true, error: true, value: true}}
                                    >                                            
                                        {({ input, meta }) => (
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        {...input}
                                                        checked={input.value}
                                                        color="primary"
                                                    />
                                                }
                                                label="Publish Tasks"
                                            />
                                        )}
                                    </Field>
                                </FormGroup>
                            </Grid>
                            <Grid item={true} xs={12} md={12} justify="flex-start">
                                <FormGroup
                                    className={classes.formGroup}
                                >
                                    <Field
                                        name="publishSuperDiaryTasks"
                                        subscription={{touched: true, error: true, value: true}}
                                    >                                            
                                        {({ input, meta }) => (
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        {...input}
                                                        checked={input.value}
                                                        color="primary"
                                                    />
                                                }
                                                label="Publish Super Diary Tasks"
                                            />
                                        )}
                                    </Field>
                                </FormGroup>
                            </Grid>
                            <Grid item={true} xs={12} md={12} justify="flex-end">
                                <div className={classes.buttonWrapper}>
                                    <Button 
                                        variant="outlined" 
                                        color="primary"
                                        type="submit"
                                        disabled={submitting || pristine || state.onSubmitLoading}
                                    >
                                        Save
                                    </Button>
                                    <Button 
                                        variant="outlined" 
                                        color="primary"
                                        type="button"
                                        disabled={submitting || pristine}
                                        onClick={onReset(form)}
                                    >
                                        Reset
                                    </Button>
                                </div>
                            </Grid>
                            {/* {printJson(values)} */}
                    </Grid>
                    </form>
                )}
            />
        </div>
    );
}

// tslint:disable-next-line: no-any
export function printJson(values: any) {
    if (values) {
        return (
            <>
                <pre>
                    {JSON.stringify(values, undefined, 2)}
                </pre>
            </>
        );
    } else {
        return (
            <>
                <FormSpy subscription={{ values: true }}>
                    {/* tslint:disable-next-line: no-shadowed-variable */}
                    {({ values }) => (
                        <pre>
                            {JSON.stringify(values, undefined, 2)}
                            {/* <RenderCount /> */}
                        </pre>
                    )}
                </FormSpy>
            </>
        );
    }
}

interface TaskPublishingMutationParams {
    publishTasks: boolean;
    publishSuperDiaryTasks: boolean;
}

const TASK_PUBLISHING_MUTATION = gql`
    mutation TaskPublishingMutation($publishTasks: Boolean, $publishSuperDiaryTasks: Boolean) {
        applicationSettings {
            taskPublisherSettings {
                update(publishTasks: $publishTasks, publishSuperDiaryTasks: $publishSuperDiaryTasks) {
                    error
                    status
                }
            }
        }
    }
`;